$(document).ready(function () {
    $('#btnLeftMenu').on('click', function () {
        let menuText = $('.menuItemLabel,.menuItemArrow');

        if ($('body').hasClass('collapsed-menu')) {
            $('body').removeClass('collapsed-menu');

            $('.showSub + .menuSub').slideDown();

            $('.sideLeft').one('transitionend', function (e) {
                menuText.removeClass('opacity0I-l');
                menuText.removeClass('lhide');
            });

        } else {
            $('body').addClass('collapsed-menu');

            $('.showSub + .menuSub').slideUp();

            menuText.addClass('opacity0I-l');
            $('.sideLeft').one('transitionend', function (e) {
                menuText.addClass('lhide');
            });
        }
        return false;
    });


    $(document).on('mouseover', function (e) {
        let menuText;
        e.stopPropagation();

        if ($('body').hasClass('collapsed-menu') && $('#btnLeftMenu').is(':visible')) {
            let targ = $(e.target).closest('.sideLeft').length;
            if (targ) {
                $('body').addClass('expand-menu');

                // show current shown sub menu that was hidden from collapsed
                $('.showSub + .menuSub').slideDown();

                menuText = $('.menuItemLabel,.menuItemArrow');
                menuText.removeClass('lhide');
                menuText.removeClass('opacity0I-l');

            } else {
                $('body').removeClass('expand-menu');

                $('.showSub + .menuSub').slideUp();

                menuText = $('.menuItemLabel,.menuItemArrow');
                menuText.addClass('opacity0I-l');
                menuText.addClass('lhide');
            }
        }
    });


    $('.menuLink.active').each(function () {
        let nextElem = $(this).next();
        let thisLink = $(this);

        if (nextElem.hasClass('menuSub')) {

            if (nextElem.is(':visible')) {
                thisLink.removeClass('showSub');
                nextElem.show();
            } else {
                $('.menuLink').each(function () {
                    $(this).removeClass('showSub');
                });

                $('.menuSub').each(function () {
                    $(this).show();
                });

                thisLink.addClass('showSub');
                nextElem.hide();
            }
            return false;
        }
    });


    // Handle menu collapse button
    $(document).on('click', '.menuItemArrow', function(e) {
        e.preventDefault();
        let $this = $(this);
        $this.closest('.menuLink').next(".menuSub").toggleClass('active');
    });

});
